export const SUPPORT_EMAIL = "support@lootstack.app";

export const DISCORD_INVITE_URL = "https://discord.gg/nsEPT2j8EU";
